import { FormKitNode } from '@formkit/core';

export function defaultToEmptyString(node: FormKitNode) {
  node.hook.input((value, next) => {
    if (value === undefined) return next('');
    return next(value);
  });
}
